export default function ColorText({ color }) {
  return <h3 style={{ color: color }}>색이 바뀌어요!</h3>;
}
